import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var confirmModal = function confirmModal(prompt, callback) {
  var template = document.createElement('template');
  template.innerHTML = "\n    <style>\n    :host {\n      display: block;\n    }\n    .modal {\n      display: none;\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background-color: rgba(0,0,0,.6);\n      justify-content: center;\n      align-items: center;\n      transition: all .3s ease;\n    }\n    .modal.open {\n      display: flex;\n    }\n    .modal-content {\n      width: 295px;\n      // height: 184px;\n      padding: 0 0 12px 0;\n      background: #FFFFFF;\n      border-radius: 12px 12px 12px 12px;\n    }\n    .modal-header {\n      height: 24px;\n      font-family: PingFang SC, PingFang SC;\n      font-weight: 500;\n      font-size: 16px;\n      color: #111111;\n      line-height: 24px;\n      text-align: center;\n      font-style: normal;\n      text-transform: none;\n      margin: 20px auto;\n    }\n    .modal-body {\n      width: 247px;\n      // height: 44px;\n      font-family: PingFang SC, PingFang SC;\n      font-weight: 400;\n      font-size: 14px;\n      color: #111111;\n      line-height: 22px;\n      text-align: left;\n      font-style: normal;\n      text-transform: none;\n      margin: 0 auto;\n    }\n    .modal-footer {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-top: 20px;\n    }\n    .model-cancel {\n      width: 124px;\n      height: 44px;\n      border-radius: 0px 0px 0px 0px;\n      font-family: PingFang SC, PingFang SC;\n      font-weight: 500;\n      font-size: 16px;\n      color: #666666;\n      line-height:44px;\n      text-align: center;\n      font-style: normal;\n      text-transform: none;\n      cursor: pointer;\n    }\n    .model-confirm {\n      cursor: pointer;\n      width: 124px;\n      height: 44px;\n      font-family: PingFang SC, PingFang SC;\n      font-weight: 500;\n      font-size: 16px;\n      color: #42A0FF;\n      line-height: 44px;\n      text-align: center;\n      font-style: normal;\n      text-transform: none;\n    }\n    </style>\n    <div class=\"modal\">\n      <div class=\"modal-content\">\n        <div class=\"modal-header\">\n          ".concat(prompt.title, "\n        </div>\n        <div class=\"modal-body\">\n          ").concat(prompt.desc, "\n        </div>\n        <div class=\"modal-footer\">\n          <div id=\"model-cancel\" class=\"model-cancel\">\n            \u53D6\u6D88\n          </div>\n          <div id=\"model-confirm\" class=\"model-confirm\">\n            \u786E\u8BA4\n          </div>\n        </div>\n      </div>\n    </div>\n  ");
  var ConfirmModal = /*#__PURE__*/function (_HTMLElement) {
    _inherits(ConfirmModal, _HTMLElement);
    var _super = _createSuper(ConfirmModal);
    function ConfirmModal() {
      var _this;
      _classCallCheck(this, ConfirmModal);
      _this = _super.call(this);
      _defineProperty(_assertThisInitialized(_this), "modal", null);
      _defineProperty(_assertThisInitialized(_this), "cancelButton", null);
      _defineProperty(_assertThisInitialized(_this), "confirmButton", null);
      _this.attachShadow({
        mode: 'open'
      });
      _this.shadowRoot.appendChild(template.content.cloneNode(true));
      _this.modal = _this.shadowRoot.querySelector('.modal');
      _this.cancelButton = _this.shadowRoot.getElementById('model-cancel');
      _this.confirmButton = _this.shadowRoot.getElementById('model-confirm');
      _this.close = _this.close.bind(_assertThisInitialized(_this));
      _this.cancelAndCallback = _this.cancelAndCallback.bind(_assertThisInitialized(_this));
      _this.confirmAndCallback = _this.confirmAndCallback.bind(_assertThisInitialized(_this));
      _this.initEventListeners();
      return _this;
    }
    _createClass(ConfirmModal, [{
      key: "initEventListeners",
      value: function initEventListeners() {
        var _this$cancelButton, _this$confirmButton;
        (_this$cancelButton = this.cancelButton) === null || _this$cancelButton === void 0 || _this$cancelButton.addEventListener('click', this.cancelAndCallback);
        (_this$confirmButton = this.confirmButton) === null || _this$confirmButton === void 0 || _this$confirmButton.addEventListener('click', this.confirmAndCallback);
      }
    }, {
      key: "disconnectEventListeners",
      value: function disconnectEventListeners() {
        var _this$cancelButton2, _this$confirmButton2;
        (_this$cancelButton2 = this.cancelButton) === null || _this$cancelButton2 === void 0 || _this$cancelButton2.removeEventListener('click', this.cancelAndCallback);
        (_this$confirmButton2 = this.confirmButton) === null || _this$confirmButton2 === void 0 || _this$confirmButton2.removeEventListener('click', this.confirmAndCallback);
      }
    }, {
      key: "cancelAndCallback",
      value: function cancelAndCallback() {
        callback(false);
        this.close();
      }
    }, {
      key: "confirmAndCallback",
      value: function confirmAndCallback() {
        callback(true);
        this.close();
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        this.initEventListeners();
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        this.disconnectEventListeners();
      }
    }, {
      key: "open",
      value: function open() {
        var _this$modal;
        (_this$modal = this.modal) === null || _this$modal === void 0 || _this$modal.classList.add('open');
      }
    }, {
      key: "close",
      value: function close() {
        var _this$modal2;
        (_this$modal2 = this.modal) === null || _this$modal2 === void 0 || _this$modal2.classList.remove('open');
      }
    }]);
    return ConfirmModal;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // 判断adapter-privacy-modal是否存在
  var privacyModelDom = document.getElementById('adapter-privacy-modal');
  if (privacyModelDom) {
    // 如果已存在，直接使用
    privacyModelDom.open();
  } else {
    customElements.define('confirm-modal', ConfirmModal);
    var modal = document.createElement('div');
    modal.innerHTML = '<confirm-modal id="adapter-privacy-modal"></confirm-modal>';
    document.body.appendChild(modal);
    document.getElementById('adapter-privacy-modal').open();
  }
};
export default confirmModal;